<app-dialog-heading [heading]="heading"></app-dialog-heading>

<div class="dialog-content">
  <form [formGroup]="addressFormGroup">
    <div class="clearfix">
      <div class="col col-6">
        <mat-form-field class="90">
          <mat-label>Address Type</mat-label>
          <mat-select [formControlName]="controls.AddressTypeCode"
                      [required]="true">
            <mat-option *ngFor="let addressType of addressTypes"
                        [disabled]="isResidentialOptionDisabled(addressType.key)"
                        [value]="addressType.key">
              {{ addressType.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col col-6">
        <app-element-input
          [cssClasses]="['w-90']"
          [customErrorMessages]="DisplayStrings.customValidatorsList"
          [customValidators]="[CustomValidator.numeric]"
          [formControlName]="controls.POBoxNumber"
          [label]="'PO Box Number'">
        </app-element-input>
      </div>
    </div>


    <div class="clearfix">
      <div class="col col-6">
        <app-element-input
          [cssClasses]="['w-90']"
          [customErrorMessages]="DisplayStrings.customValidatorsList"
          [customValidators]="[CustomValidator.numeric]"
          [formControlName]="controls.AddressLine1Number"
          [label]="'Address Line 1 Number'"
          [required]="true">
        </app-element-input>
      </div>
      <div class="col col-6">
        <app-element-input
          [cssClasses]="['w-90']"
          [formControlName]="controls.AddressLine1Name"
          [label]="'Address Line 1 Name'"
          [required]="true">
        </app-element-input>
      </div>
    </div>

    <div class="clearfix">
      <div class="col col-6">
        <app-element-input
          [cssClasses]="['w-90']"
          [customErrorMessages]="DisplayStrings.customValidatorsList"
          [customValidators]="[CustomValidator.numeric]"
          [formControlName]="controls.AddressLine2Number"
          [label]="'Address Line 2 Number'">
        </app-element-input>
      </div>
      <div class="col col-6">
        <app-element-input
          [cssClasses]="['w-90']"
          [formControlName]="controls.AddressLine2Name"
          [label]="'Address Line 2 Name'">
        </app-element-input>
      </div>
    </div>

    <div class="clearfix">
      <div class="col col-6">
        <mat-form-field class="w-90">
          <mat-label>Suburb</mat-label>
          <input (input)="onSuburbSearchInput($event)"
                 [formControlName]="controls.Suburb"
                 [matAutocomplete]="suburbAuto"
                 matInput
                 placeholder="Type the first 3 letters to search"
                 required>
          <mat-autocomplete #suburbAuto="matAutocomplete" [panelWidth]="'20vw'">
            <mat-option *ngFor="let suburb of filteredSuburbs;"
                        (onSelectionChange)="onSuburbSelectionChanged($event.source.value)"
                        [value]="suburb.value">
              {{ suburb.value }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col col-6">
        <mat-form-field>
          <mat-label>Country</mat-label>
          <mat-select [formControlName]="controls.CountryCode">
            <mat-option *ngFor="let country of countries" [value]="country.code">
              {{ country.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="clearfix">
      <div class="col col-6">
        <app-element-input
          [cssClasses]="['w-90']"
          [customErrorMessages]="DisplayStrings.customValidatorsList"
          [customValidators]="[CustomValidator.numeric]"
          [formControlName]="controls.PostalCode"
          [label]="'Postal Code'"
          [required]="true">
        </app-element-input>
      </div>
    </div>
  </form>
</div>

<mat-dialog-actions align="center" class="dialog-button-container">
  <button (click)="onCancel()" class="dialog-button" color="warn" mat-raised-button>Cancel</button>
  <button (click)="onSave()" [disabled]="!addressFormGroup.valid" class="dialog-button"
          color="primary"
          mat-raised-button>
    Save
  </button>
</mat-dialog-actions>
